import axios from 'axios'
import { PAGAR_ME_BIN_API_ENDPOINT } from 'shared/envs'

const baseURL = PAGAR_ME_BIN_API_ENDPOINT()

export const pagarmeBinHttpClient = axios.create({ baseURL })
